"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.processing.llm': 'Processing with AI...',
};
